<template>
  <div>
    <b-modal
      id="modal-edit"
      title="Edit Tipe Pelunasan"
      no-close-on-backdrop
    >
      <template v-if="editState.isLoading">
        <div class="d-flex justify-content-center align-items-center" style="min-height:150px;">
          <b-spinner class="loading-spinner"></b-spinner>
        </div>
      </template>

      <template v-else-if="editState.isError">
        <b-alert show variant="danger">
          Gagal memuat data. Mohon coba lagi nanti.
        </b-alert>
      </template>

      <template v-else-if="!editState.data">
        <div class="text-center">
          <p>Data tidak tersedia</p>
        </div>
      </template>

      <template v-else>
        <div class="detail-data-wrapper mb-0">
          <h6 class="form-title">INFORMASI TRANSAKSI</h6>

          <b-row class="mb-2">
            <b-col cols="12" md="5"><p class="mb-0">No. Kwitansi</p></b-col>
            <b-col cols="12" md="7"><p class="font-600 mb-0"> {{ editState.data.noKwitansi }}</p></b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col cols="12" md="5"><p class="mb-0">No. Faktur</p></b-col>
            <b-col cols="12" md="7"><p class="font-600 mb-0"> {{ editState.data.noFaktur }}</p></b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col cols="12" md="5"><p class="mb-0">Metode Pembayaran</p></b-col>
            <b-col cols="12" md="7">
              <p class="font-600 mb-0"> {{ editState.data.isTunai ? "Tunai" : "Transfer" }}</p>
            </b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col cols="12" md="5"><p class="mb-0">Pembayaran di Cabang</p></b-col>
            <b-col cols="12" md="7"><p class="font-600 mb-0"> {{ editState.data.cabang }}</p></b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col cols="12" md="5"><p class="mb-0">Tanggal Pembayaran</p></b-col>
            <b-col cols="12" md="7">
              <p class="font-600 mb-0"> {{ $helper.changeDateFormat(editState.data.tanggalPembayaran) }}</p>
            </b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col cols="12" md="5"><p class="mb-0">Tipe Pelunasan (Saat Ini)</p></b-col>
            <b-col cols="12" md="7">
              <p class="font-600 mb-0" v-if="editState.data.tipePelunasan == 1">
                Nasabah + SBG
              </p>
              <p class="font-600 mb-0" v-else-if="editState.data.tipePelunasan == 2">
                Nasabah + Nota Hilang
              </p>
              <p class="font-600 mb-0" v-else-if="editState.data.tipePelunasan == 3">
                Pelunasan Diwakilkan + SBG
              </p>
              <p class="font-600 mb-0" v-else-if="editState.data.tipePelunasan == 4">
                Pelunasan Diwakilkan + Surat Kuasa PGI (Apabila SBG Hilang)
              </p>
              <p class="font-600 mb-0" v-else> - </p>
            </b-col>
          </b-row>

          <h6 class="form-title mt-4">AKSI</h6>
          <b-row class="mb-2">
            <b-col>
              <b-form-group label="Tipe Pelunasan">
                <b-form-select v-model="localForm.tipePelunasan">
                  <b-form-select-option v-for="(item, index) in OPTIONS_TIPE_PELUNASAN"
                    :value="item.value"
                    :key="index">
                    {{ item.text }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </template>

      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="secondary" name="closeEditBtn" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" name="submitEditBtn" @click="onConfirm()">
          Submit
        </b-button>
      </template>
    </b-modal>

     <ModalConfirm id="modal-confirm-edit-tipe-pelunasan" title="Confirm edit tipe pelunasan" :isSubmitting="localForm.isLoading"
            desc="Apakah anda yakin untuk edit tipe pelunasan ini ?" @submit="onSubmitForm()" />
  </div>
</template>

<script>
import CONSTANTS from '@/constants'

export default {
  name: "ModalEditTipePelunasan",
  props: {
    editState: { type: Object, required: true },
    formEdit: { type: Object, required: true }
  },
  data() {
    return {
      localForm: { ...this.formEdit }
    };
  },
  methods: {
    onConfirm() {
        this.$bvModal.show("modal-confirm-edit-tipe-pelunasan")
    },
    onSubmitForm() {
        this.$emit('submit', this.localForm)
    },
  },
  computed: {
    OPTIONS_TIPE_PELUNASAN() {
      return CONSTANTS.OPTIONS_TIPE_PELUNASAN.slice(1);
    }
  },
  watch: {
    formEdit: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.localForm = { ...newVal };
      }
    }
  }
};
</script>
